import styled from 'styled-components'

export const SidebarModalLabelWrap = styled.div`
  padding: ${(p) => (p.padding ? p.padding : '8px 32px')};
  background-color: var(--t-modal-label-bg);
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const SidebarModalLabelTitle = styled.div`
  color: var(--t-modal-label-color);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`
